export default __webpack_public_path__ + "static/media/health-svgrepo-com.bd821832.svg";